export default __webpack_public_path__ + "static/media/OpenSans-SemiBoldItalic.01305b83.woff";